import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Text } from '@hhgtech/hhg-components/mantine'
import { AspectRatio, Box, Flex, FlexProps, rem } from '@mantine/core'
import { useIntl } from 'react-intl'

import { assetImagePath } from 'interfaces/constants'

type VideoItem = {
  title: string
  url: string
  image?: string
  indexNumber?: number
}
type VideoItemProps = {
  active?: boolean
  showIndex?: boolean
} & VideoItem &
  FlexProps

const VideoItem = ({
  title,
  image,
  active,
  url,
  indexNumber,
  showIndex,
  ...boxProps
}: VideoItemProps) => {
  const { formatMessage: f } = useIntl()
  return (
    <Box {...boxProps}>
      <Flex
        className="pointer-event-child-none"
        data-event-category="Service Connection"
        data-event-action="Video List  Click"
        data-event-label={url}
        gap={rem(8)}
        align={'center'}
        sx={(theme) => ({
          [theme.fn.smallerThan('sm')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
          },
        })}
      >
        {showIndex && (
          <Box>
            <Text size="s4" weight="semiBold">
              {indexNumber}
            </Text>
          </Box>
        )}
        <Box
          sx={(theme) => ({
            position: 'relative',
            [theme.fn.largerThan('sm')]: { width: rem(120) },
          })}
        >
          <AspectRatio ratio={120 / 68}>
            <img
              loading="lazy"
              src={image}
              alt={title}
              onError={(e) => {
                e.currentTarget.src = `${assetImagePath}/default-image.jpg`
              }}
            />
          </AspectRatio>
          <Flex
            align={'center'}
            justify={'center'}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: active ? 'rgba(0, 0, 0, .5)' : 'transparent',
              transition: 'all .2s ease',
            }}
          >
            {active ? (
              <Text size="s4" weight="semiBold" color="#fff">
                {f({
                  id: 'common.playing',
                  defaultMessage: 'Playing ...',
                })}
              </Text>
            ) : (
              <img
                src={CommonGAssets.getAssetPath('play-circle-bg.svg')}
                alt="play"
                loading="lazy"
              />
            )}
          </Flex>
        </Box>
        <Box
          sx={(theme) => ({
            [theme.fn.largerThan('sm')]: { width: `calc(100% - 128px)` },
          })}
        >
          <Text
            size="s3"
            weight="semiBold"
            color={active ? 'blue.6' : undefined}
            sx={{
              display: '-webkit-box',
              '-webkit-line-clamp': '2',
              '-webkit-box-orient': 'vertical',
              overflow: 'hidden',
            }}
          >
            {title}
          </Text>
        </Box>
      </Flex>
    </Box>
  )
}

export { VideoItem }
